<template>
   <div>
        <map-tool 
          mapType="example"
          :checkLogin="false">
        </map-tool>
    </div>
</template>

<script>
import MapTool from '../components/MapTool.vue'

export default {
  metaInfo: {
    title: '事件风暴在线工具', // set a title
    meta: [{                 // set meta
      name: 'keywords',
      content: '事件风暴在线工具，EventStorming Tool'
    }, {
      name: 'description',
      content: '事件风暴EventStorming 是一个单一的大型研讨会，涉及我们期望合作解决关键业务问题的所有关键人员。 我们将建立整个业务线的行为模型，突出协作、边界、责任以及相关参与者和利益相关者的不同观点'
    }],
  },
  components: { MapTool },
  name: "EventToolExample",
  created() {
    this.$nextTick(() => {
      //document.title = this.$route.query.name+'-事件风暴'
      document.title = '事件风暴体验'
    })
  },
}
</script>